import styled from 'styled-components';

const Footer = styled.div`
  position: relative;
  flex: 0 0 auto;
`;

export default Footer;
